export default {
    //localhost
    //API_URL: 'http://localhost:8080'  
    //test
    API_URL: 'https://cts-api.herokuapp.com'
    //produccion
    //API_URL: 'https://api-cts.herokuapp.com'
    
  }